module.exports = __webpack_public_path__ + "img/cn-pro-t.ad69a391.png";